
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium-themes/onepirate/sign-in",
      function () {
        return require("private-next-pages/premium-themes/onepirate/sign-in.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium-themes/onepirate/sign-in"])
      });
    }
  